import createIcon from '../../createIcon';

/**
 * @component @name VerticalDistribute
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMlY0SDJWMkgyMlpNNyAxMC41VjEzLjVIMTdWMTAuNUg3Wk0yIDIwVjIySDIyVjIwSDJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VerticalDistribute = createIcon('VerticalDistribute', [
  ['path', { d: 'M22 2V4H2V2H22ZM7 10.5V13.5H17V10.5H7ZM2 20V22H22V20H2Z', key: 'pmssay' }],
]);

export default VerticalDistribute;
